<template>
  <div>
    <a-modal v-model="visible" :width="880" title="关联流程" :footer="null" :mask-closable="false">
      <a-table :columns="columns" :pagination="false" :data-source="data" row-key="workflow_id" size="small" :loading="loading">
        <a slot="workflowTitle" slot-scope="record" class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
        <a-popconfirm slot="action" slot-scope="record" title="请确认是否关联该流程" ok-text="是" cancel-text="否" @confirm="onAssociation(record)">
          <a>关联</a>
        </a-popconfirm>
        <span slot="status" slot-scope="record">
          <a-badge :status="workflowStatus[record.status].status" :text="workflowStatus[record.status].label" />
        </span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { workflowStatus } from '@/utils/dictionary';
import { associableWorkflow, associationWorkflow } from '@/api/project/workflow';

const columns = [
  {
    title: '流程ID',
    width: 80,
    dataIndex: 'workflow_id'
  },
  {
    title: '流程标题',
    ellipsis: true,
    with: 500,
    scopedSlots: { customRender: 'workflowTitle' }
  },
  {
    title: '镜像版本',
    ellipsis: true,
    width: 200,
    dataIndex: 'imageVersion'
  },
  {
    title: '状态',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    width: 80,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  data() {
    return {
      columns,
      data: [],
      workflowStatus,
      loading: false,
      visible: false,
      workflowId: null,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    link() {
      return (record) => {
        const route = this.$router.resolve({ name: 'page:project:workflow:detail',
          params: { project_id: record.project_id },
          query: { workflowId: record.workflow_id }});
        return route.href;
      };
    }
  },
  methods: {
    onOpen(workflow_id) {
      this.visible = true;
      this.loading = true;
      this.workflowId = workflow_id;
      associableWorkflow({ project_id: this.projectId, workflow_id }).then(res => {
        this.loading = false;
        this.data = res.data.items;
      });
    },
    onAssociation(record) {
      associationWorkflow({ project_id: this.projectId, workflow_id: this.workflowId, target_workflow_id: record.workflow_id }).then(() => {
        this.visible = false;
        const self = this;
        this.$confirm({
          title: '关联成功，是否跳转至关联流程',
          okText: '是, 立即跳转',
          okType: 'primary',
          cancelText: '不, 留在当前流程',
          onOk() {
            self.$emit('reload');
            const route = self.$router.resolve({ name: 'page:project:workflow:detail',
              params: { project_id: record.project_id },
              query: { workflowId: record.workflow_id }});
            window.open(route.href);
          },
          onCancel() {
            self.$emit('reload');
          }
        });
      });
    }
  }
};
</script>
